import {SecondaryButton} from 'components';
import React from 'react';
import Chart from 'react-apexcharts';

function FraudMonitoringChart() {
  const chartData = {
    series: [
      {
        name: 'AML SCREENING',
        data: [350, 205, 180, 95, 155, 285, 95, 50, 400, 220, 190],
      },
      {
        name: 'CREDIT CHECK',
        data: [50, 260, 110, 55, 100, 140, 200, 155, 160, 145, 115],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {show: false},
        background: '#FFFFFF',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '75%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {enabled: false},
      stroke: {show: true, width: 4, colors: ['transparent']},
      xaxis: {
        categories: [
          'JAN',
          'FEB',
          'MAR',
          'APR',
          'MAY',
          'JUN',
          'JUL',
          'AUG',
          'SEP',
          'OCT',
          'NOV',
        ],
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      yaxis: {
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      fill: {opacity: 1},
      grid: {
        show: true,
        borderColor: '#F9F9F9',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {lines: {show: false}},
        yaxis: {lines: {show: true}},
        padding: {left: 10, right: 10},
      },
      legend: {
        show: false,
      },
      colors: ['#DC6803', '#2A5392'],
    },
  };

  const legendData = chartData.series.map((item, index) => ({
    label: item.name,
    color: chartData.options.colors[index],
  }));

  return (
    <div className="bg-white mt-5 h-full shadow-cards rounded-xl border-[0.5px] border-[#EFEFEF]">
      <div className="bg-[#F9F9F9] py-3 px-6 rounded-t-xl">
        <p className="font-medium text-sm xl:text-base text-deepBlue">
          Fraud Monitoring
        </p>
      </div>

      <div className="flex flex-wrap gap-4 items-center justify-between p-6">
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {legendData.map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <span
                className="w-3 h-3 rounded-full"
                style={{backgroundColor: item.color}}
              ></span>
              <span className="text-xs text-gray-600 font-medium uppercase">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <SecondaryButton buttonText="Filter" />
      </div>

      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default FraudMonitoringChart;
